import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              吃瓜优势
            </h2>
            <p className="text-sm text-foreground-500">
              为什么千万瓜友选择在吃瓜群获取最新爆料
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featureItems.map((item) => (
              <div
                key={item.id}
                className="group p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:-translate-y-1"
              >
                <span className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100 mb-5 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-2xl text-primary-600`} />
                </span>
                <h3 className="font-heading text-lg text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}